/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import config from "../../../config";
import axiosClient from "../../../_helpers/http.helper";
import ModalDialog from "../../widgets/ModalDialog/ModalDialog";
import { TEXT_TYPES } from '../../../constants/APP_CONSTANTS';

export default class PriceCalculation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isbn:'',  
            showModal: false,
        };
    }

    closeModal = () => {
        this.setState({
            showModal: false
        });
    };

  calculatePrice = () => {
      const calculatePriceRoute
            = config.contentService.baseUrl
            + config.contentService.routes.calculatePrice;
      const requestBody = [
          this.state.isbn
      ];
      axiosClient.post(calculatePriceRoute, requestBody)
          .then((response) => {
              if (response.status === 200 ){
                  this.setState({
                      showModal: true,
                      message: "Success! Please perform a search in Collections to see the price calculation result."
                  });
              }
          }).catch(() => {
              this.setState({
                  showModal: true,
                  message: "Error! Unable to start price calculation, please try again later."
              });
          });
  };

  render() {
      const {showModal,message} = this.state;
      return (
          <div className="content-home-page cc-creation-status">
              <div>
                  <label className="pe-page-title--small">
                      {TEXT_TYPES.PRICE_CALCULATION}
                  </label>
                  <hr />
                  <div><h3> ISBN </h3></div>
                  <div className="search-input-field">
                      <input
                          type="text"
                          className="pe-textInput--basic input-field" style = {{width :'250px'}}
                          value={this.state.isbn}
                          onChange={e => {
                              this.setState({isbn: e.target.value});
                          }}
                          placeholder={"ISBN-13 only"}
                      /></div>
                  <ModalDialog
                      title={"Price Calculation Info"} 
                      showModal={showModal} 
                      showSuccess={false} 
                      onCancel={this.closeModal}
                      showCancel={false}>
                      <p>{message}</p>
                  </ModalDialog>
                  <div>
                      <div className="buttons">
                          <button type="file" name="files" className="pe-btn--btn_large " style = {{marginTop: '15px'}} disabled={!this.state.isbn} onClick={this.calculatePrice}>Calculate Price </button>
                      </div>
                  </div>
              </div> 
                
          </div>
      );
  }
}


// WEBPACK FOOTER //
// ./src/components/pages/ContentManagement/PriceCalculation.js